/**
 *
 * @Copyright 2024 UNLOCKIT DECENTRALIZATION, LDA
 * Development by VOID Software, SA
 *
 */

import React, { FunctionComponent } from 'react';
import { TranslationContext, withTranslationContext } from '../controllers/TranslationContext';
import { ReactComponent as NotFoundIcon } from '../../assets/images/not_found.svg';
import { DefaultLayout } from '../elements/layouts/DefaultLayout';

interface OwnProps extends TranslationContext { }

const NotFoundPageComponent: FunctionComponent<OwnProps> = (props: OwnProps) => {
    const { t } = props;

    return (
        <DefaultLayout>
            <div className="not-found-page information-page primary-gradient-bg">
                <div className="information-page__content-wrap">
                    <div className="information-page__content">
                        <NotFoundIcon />
                        <h1>{t('notFound.title')}</h1>
                        <p>{t('notFound.description')}</p>
                    </div>
                </div>
            </div>
        </DefaultLayout>
    );
};

const NotFoundPage = withTranslationContext(NotFoundPageComponent);
export { NotFoundPage };
